"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLegacyWrapper = void 0;
const prng = __importStar(require("./prng"));
const svg = __importStar(require("./svg"));
const options_1 = require("./options");
function createLegacyWrapper(style) {
    return (random, options) => {
        var _a;
        options = Object.assign(options, options_1.merge(style, options));
        let result = style.create({
            prng: prng.create(random.seed),
            options: options,
        });
        return `
        <svg ${svg.createAttrString(result.attributes)}>
            ${svg.getMetadata(style)}
            ${(_a = result.head) !== null && _a !== void 0 ? _a : ''}
            ${result.body}
        </svg>
    `;
    };
}
exports.createLegacyWrapper = createLegacyWrapper;
